
    import './styles.scoped.css';
    export default {
  "segment": "awsui_segment_8cbea_7d5wh_97",
  "disabled": "awsui_disabled_8cbea_7d5wh_174",
  "selected": "awsui_selected_8cbea_7d5wh_182",
  "icon": "awsui_icon_8cbea_7d5wh_203",
  "with-text": "awsui_with-text_8cbea_7d5wh_207",
  "with-no-text": "awsui_with-no-text_8cbea_7d5wh_213",
  "root": "awsui_root_8cbea_7d5wh_222",
  "segment-part": "awsui_segment-part_8cbea_7d5wh_257",
  "select": "awsui_select_8cbea_7d5wh_182",
  "segment-count-2": "awsui_segment-count-2_8cbea_7d5wh_276",
  "segment-count-3": "awsui_segment-count-3_8cbea_7d5wh_281",
  "segment-count-4": "awsui_segment-count-4_8cbea_7d5wh_286",
  "segment-count-5": "awsui_segment-count-5_8cbea_7d5wh_291",
  "segment-count-6": "awsui_segment-count-6_8cbea_7d5wh_296"
};
  